import React from 'react'
import { Link } from 'react-router-dom'
import youtube from '../../images/youtube.png'
import facebookimg from '../../images/facebook.png'
import instagram from '../../images/instagram.png'
import linkedin from '../../images/linkedin.png'
import logo from '../../images/site_logo/LOGO.svg'
import appImg from '../../images/download-app.png'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const SubmitHandler = (e) => {
    e.preventDefault()
}


const Footer = (props) => {
    return (
        <footer className="site_footer footer_layout_1">
            <div className="content_box">
                <div className="container">
                    {/* <div className="diract_contact_links text-white">
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon1} alt="Mail SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Write to us</h3>
                                <p className="mb-0">
                                    Techco@gmail.com
                                </p>
                            </div>
                        </div>
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon2} alt="Calling Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title"> Call Us (USA)</h3>
                                <p className="mb-0">
                                    +(1) 1230 452 8597
                                </p>
                            </div>
                        </div>
                        <div className="iconbox_block layout_icon_left">
                            <div className="iconbox_icon">
                                <img src={icon3} alt="Map Mark Check SVG Icon" />
                            </div>
                            <div className="iconbox_content">
                                <h3 className="iconbox_title">Our Office</h3>
                                <p className="mb-0">
                                    Waterloo, Park, Australia
                                </p>
                            </div>
                        </div>
                    </div> */}
                    <div className="footer_main_content">
                        <div className="row justify-content-lg-between">
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footer_widget pe-md-3">
                                    <img src={logo} alt="Site Logo" />
                                    <p>
                                        We’re on a mission to simplify hotel and resort management — so you can focus on what truly matters: delivering unforgettable guest experiences.  
                                    </p>

                                    <center>
                                    <a href='https://download.easemyhotel.io/easemyhotel.apk' target='_blank' download={true} className='text-center'>
                                        <img src={appImg} style={{width:240}} />
                                    </a>
                                    </center>
                                    <form  onSubmit={SubmitHandler}>
                                        {/* <label htmlFor="footer_mail_input">
                                            <img src={icon4} alt="Mail SVG Icon" />
                                        </label> */}
                                        {/* <input class="form-control" type="email" name="email" placeholder="Sign up today" /> */}
                                        {/* <button type="submit"><i className="fa-solid fa-paper-plane"></i></button> */}
                                    </form>
                                    {/* <ul className="social_links_block unordered_list">
                                        <li><Link onClick={ClickHandler} to="/">Facebook</Link></li>
                                        <li><Link onClick={ClickHandler} to="/">Twitter</Link></li>
                                        <li><Link onClick={ClickHandler} to="/">Linkdin</Link></li>
                                    </ul> */}
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Solutions</h3>
                                    <ul className="icon_list unordered_list_block">
                                        <li><span className="icon_list_text"> Hotel Management Software</span></li>
                                        <li><span className="icon_list_text"> Airbnb Management Software </span></li>
                                        <li><span className="icon_list_text"> Resort Management Software </span></li>
                                        <li><span className="icon_list_text"> Homestay Management Software </span></li>
                                        <li><span className="icon_list_text"> Vacation Rental Management Software</span></li>
                                        <li><span className="icon_list_text"> Guest House Management Software</span></li>
                                        <li><span className="icon_list_text"> Restaurant Management Software</span></li>
                                        <li><span className="icon_list_text"> Channel Manager (OTA) Management Software</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Resources</h3>
                                    <ul className="icon_list unordered_list_block">
                                        <li><a href="https://easemyhotel.io/blog/"><span className="icon_list_text"> Blog</span></a></li>
                                        <li><Link to="/ebook">E-Book</Link></li>
                                        <li><a href="https://easemyhotel.io/break-even-occupancy-calculator.html" target='_blank' >Break-even Occupancy Calculator</a></li>
                                        <li><a href="https://easemyhotel.io/ota-commission-leakage-direct-booking-roi-calculator.html" target='_blank' >OTA Commission Leakage Calculator</a></li>
                                        <li><a href="https://easemyhotel.io/revpar-adr-occupancy-calculator.html" target='_blank' >RevPAR / ADR / Occupancy Calculator</a></li>
                                        <li><a href="https://easemyhotel.io/food-cost-menu-engineering-tool.html" target='_blank' >Food Cost % + Menu Engineering Tool</a></li>
                                        
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-12 col-sm-12">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Company</h3>
                                    <ul className="icon_list unordered_list_block">
                                        
                                        <li><Link onClick={ClickHandler} to="/about"> <span className="icon_list_text"> About us </span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact"> <span className="icon_list_text"> Contact us </span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"> <span className="icon_list_text"> <i className="fa fa-phone"></i> &nbsp; +91-8299406767 </span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"> <span className="icon_list_text"> <i className="fa fa-envelope"></i> &nbsp; support@easemyhotel.io </span></Link></li>
                                    </ul>
                                </div>
                            </div>

                            {/* <div className="col-lg-2 col-md-6 col-sm-6">
                                <div className="footer_widget">
                                    <h3 className="footer_info_title">Integrations</h3>
                                    <ul className="icon_list unordered_list_block">
                                        <li><Link onClick={ClickHandler} to="/"> <span className="icon_list_text"> Partner Programs </span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"> <span className="icon_list_text"> Booking channels </span></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"> <span className="icon_list_text"> Hotel App Store </span></Link></li>
                                        
                                    </ul>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_bottom">
                <div className="container d-md-flex align-items-md-center justify-content-md-between">
                    <div className="copyright_text">
                        <ul className="social_links_block unordered_list">
                            <li><Link onClick={ClickHandler} to="/privacy-policy"> <span className="icon_list_text"> Privacy Policy</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/terms-conditions"> <span className="icon_list_text"> Terms and Conditions </span></Link></li>
                            <li><Link onClick={ClickHandler} to="/refund"> <span className="icon_list_text"> Refund & Cancellation Policy </span></Link></li>
                        </ul>

                       {/* <ul className="social_links_block unordered_list">
                            <li><Link onClick={ClickHandler} to="/"><img src={facebookimg}/></Link></li>
                            <li><Link onClick={ClickHandler} to="/"><img src={instagram}/></Link></li>
                            <li><Link onClick={ClickHandler} to="/"><img src={linkedin}/></Link></li>
                            <li><Link onClick={ClickHandler} to="/"><img src={youtube}/></Link></li>
                        </ul> */}
                    </div>
                    
                    <p className="copyright_text m-0">
                        © 2025  Easemyhotel. All Rights Reserved
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;